import api from './api';

export type DespesaStatus = 'pendente' | 'pago' | 'vencido' | 'cancelado';
export type DespesaDataField = 'vencimento' | 'pagamento';
export type Frequencia = 'mensal' | 'quinzenal' | 'anual';

export interface Despesa {
    id: number;
    descricao: string;
    valor_pagar: number;
    data_vencimento: string;
    data_pagamento?: string | null;
    status: DespesaStatus;
    entidade_id?: number | null;
    categoria_id?: number | null;
    entidade_nome?: string;
    categoria_nome?: string;
    is_recorrente?: boolean;
    total_parcelas?: number;
    parcela_atual?: number;
    grupo_recorrencia?: string | null;
    // Recorrência real
    frequencia?: Frequencia | null;
    proxima_geracao?: string | null;
    recorrencia_origem_id?: number | null;
}

export interface DespesasListFilters {
    mes?: string;
    ano?: string;
    data_inicio?: string;
    data_fim?: string;
    /** Qual data usar para filtrar — vencimento (default) ou pagamento. */
    data_field?: DespesaDataField;
    /** Por default cancelados são ocultos. Setar true para incluir. */
    incluir_cancelado?: boolean;
}

export const despesasService = {
    list: async (filters?: DespesasListFilters) => {
        const response = await api.get<Despesa[]>('/despesas', { params: filters });
        return response.data;
    },
    create: async (data: Partial<Despesa>) => {
        const response = await api.post('/despesas', data);
        return response.data;
    },
    update: async (id: number, data: Partial<Despesa>) => {
        const response = await api.put(`/despesas/${id}`, data);
        return response.data;
    },
    delete: async (id: number) => {
        await api.delete(`/despesas/${id}`);
    },
    /** Marca a despesa como paga em 1 chamada — atalho da UI. */
    marcarPago: async (id: number, dataPagamento?: string): Promise<Despesa> => {
        const response = await api.post(`/despesas/${id}/marcar-pago`, {
            data_pagamento: dataPagamento ?? new Date().toISOString().substring(0, 10),
        });
        return response.data;
    },
};
